/**
 * Just patch emitter prototype with on alias
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var Emitter = require('cjs-emitter');

/**
 * Alias to addListener function
 *
 * @type {Emitter.addListener}
 */
Emitter.prototype.on = Emitter.prototype.addListener;


module.exports = Emitter;
